import { NavigationTabs } from '@monorepo/shared/componentsV2/NavigationTabs';
import { BaseNavBar } from '@monorepo/shared/componentsV2/NavigationTabs/BaseNavBar';
import { useHasAnalyticsAccess } from '@monorepo/shared/hooks/permissions/useHasAnalyticsPermissions';
import { useLastProject } from '@monorepo/shared/hooks/useLastProject';
import Analytics from '@svg/analytics.svg';
import DataSetupIcon from '@svg/data-setup.svg';
import MapDashboard from '@svg/m-map-dashboard.svg';
import SiteDashboard from '@svg/m-site-dashboard.svg';
import classnames from 'classnames';
import React, { useMemo } from 'react';
import { SettingsTab } from './SettingsTab';
import { TabContainer, TabLabelContainer, TabLabelText } from './styled';

function getLabel(icon: React.ReactNode, label: string) {
  return ({ isActive }: { isActive: boolean }) => (
    <TabContainer>
      <TabLabelContainer className={classnames({ selected: isActive })}>
        <span aria-hidden>{icon}</span>
        <TabLabelText>{label}</TabLabelText>
      </TabLabelContainer>
    </TabContainer>
  );
}

export function NavBar() {
  const { project, isLoading } = useLastProject();
  const hasAnalyticsAccess = useHasAnalyticsAccess();

  const options = useMemo(
    () => [
      ...(hasAnalyticsAccess
        ? [
            {
              href: '/vortex/analytics',
              isLegacy: false,
              label: getLabel(<Analytics />, 'Analytics'),
            },
          ]
        : []),
      {
        href: `/vortex/organizations/${project?.organization_id}/sites/${project?.id}`,
        isLegacy: false,
        label: getLabel(<SiteDashboard />, 'Sites'),
      },
      {
        href: `/organizations/${project?.organization_id}/projects/${project?.id}`,
        isLegacy: true,
        label: getLabel(<MapDashboard />, 'Maps'),
      },
      {
        href: `/vortex/organizations/${project?.organization_id}/data-setup`,
        isLegacy: false,
        label: getLabel(<DataSetupIcon />, 'Setup'),
      },
    ],
    [hasAnalyticsAccess, project?.id, project?.organization_id],
  );

  return (
    <BaseNavBar>
      <NavigationTabs
        label="Main"
        isLoading={isLoading}
        orientation="vertical"
        options={options}
      />
      <SettingsTab />
    </BaseNavBar>
  );
}
